import { useSelector } from 'react-redux';
import { useStripeAlert } from '../settings/stripeStatus';

/**
 * Unread notification count, shared by every consumer (the desktop bell and
 * the mobile side menu). Prefers the server-tracked count refreshed by the
 * cheap /unread-count poll, and falls back to deriving it from the loaded
 * items when the server count has not arrived yet.
 */
export const useUnreadCount = () => {
  const items = useSelector(s => s.notifications?.items || []);
  const serverUnreadCount = useSelector(s => s.notifications?.unreadCount);
  const lastViewedAt = useSelector(s => s.notifications?.lastViewedAt || 0);
  // The pinned Stripe alert counts as one unread until the account is fixed,
  // so the bell and the burger dot keep pointing at it.
  const stripe = useStripeAlert();

  const base = typeof serverUnreadCount === 'number'
    ? serverUnreadCount
    : items.filter(i => i.timestamp > lastViewedAt).length;
  return base + (stripe.active ? 1 : 0);
};

export default useUnreadCount;
